import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './Content.css';

const committeeItems = [
  'Receive internal reports on suspicions of money laundering',
  'Investigate such reports',
  'Report suspicious events to relevant authorities',
  'Ensure adequacy of arrangements for awareness and training of staff',
  'Report at least annually to the governing body on operations and effectiveness of systems and checks.',
  'Monitor day-to-day anti-money laundering operations concerning: new product development, client acquisition, and changes in business profile.',
];

const launderingActs = [
  'Acquisition, use, or possession of the criminal property',
  'Handling proceeds from theft, fraud, and tax evasion',
  'Knowingly getting involved with criminal or terrorist property',
  'Involvement in the facilitation of laundering criminal or terrorist property',
  'Investing illicit proceeds in other financial products',
  'Investing such proceeds through the acquisition of property/assets',
  'Criminal property transfer.',
];

const launderingStages = [
  'Placement: Disposal of the initial proceeds into a bank account.',
  'Layering: Money is moved through the system in a series of financial transactions to conceal its origin',
  'Integration: Criminals are free to utilize the money once it has been removed from the system disguised as \'clean\' funds.',
];

const Content = () => {
  return (
    <section className="privacy-content">
      <div className="privacy-content__inner">
        <Reveal className="privacy-content__block">
          <h2 className="privacy-content__heading">Corporate Policy Scope</h2>
          <p className="privacy-content__text">
            The policy applies to all VBS Financial Securities directors,
            employees, products, and services. Business units across VBS
            Financial Securities are to collaborate for an integral effort
            against money laundering. Each unit and location has put in place
            risk-based procedures to detect, prevent and report any such
            transactions. All efforts will be documented and retained.
            Initiating Suspicious Activity Reports (&apos;SARs&apos;) or other
            reporting to the appropriate law enforcement or regulatory agencies
            is the responsibility of The AML Compliance Committee. Any contact
            by law enforcement or regulatory agencies related shall be directed
            to the AML Compliance Committee.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={40}>
          <h2 className="privacy-content__heading">The committee is to:</h2>
          <ul className="privacy-content__list">
            {committeeItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </Reveal>

        <Reveal className="privacy-content__block" delay={80}>
          <h2 className="privacy-content__heading">The Policy</h2>
          <p className="privacy-content__text">
            VBS Financial Securities has put in place a necessary policy
            determined to actively prevent money laundering and activity that
            facilitates or funds terrorist or criminal activities. VBS Financial
            Securities has committed itself to AML compliance and requires its
            executives, employees, and producers to adhere to standards and
            practices for preventing the use of its products and services for
            money laundering.
          </p>
          <p className="privacy-content__text">
            In the policy, money laundering is largely defined as acts designed
            to conceal the true origins of criminally-derived proceeds so that
            unlawful proceeds appear to have been
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={120}>
          <h2 className="privacy-content__heading">What is money laundering?</h2>
          <p className="privacy-content__text">
            Money laundering is the process through which criminally-obtained
            money or assets are exchanged for &quot;clean&quot; money or other
            assets with no obvious link to criminal origins.
          </p>
          <p className="privacy-content__text">
            Criminal property may take various forms, including money,
            money&apos;s worth, securities, tangible property, and intangible
            property. It also covers money funding terrorism.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={160}>
          <h2 className="privacy-content__heading">Money laundering acts include:</h2>
          <ul className="privacy-content__list">
            {launderingActs.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <p className="privacy-content__text">
            Methods of money laundering may range from the purchase and resale
            of luxury items such as a vehicle or jewelry to passing money on a
            complex web of legitimate operations. Generally, it starts with
            cash. It is important to understand money laundering is defined in
            terms of criminal property which can be in any conceivable legal
            form, whether money, rights, real estate, or any other benefit; if
            you know or suspect such assets either directly or indirectly
            resulting from criminal activity and you do not speak up, then you
            too might be partaking in the process.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={200}>
          <h2 className="privacy-content__heading">
            A money laundering process follows three stages:
          </h2>
          <ol className="privacy-content__list privacy-content__list--ordered">
            {launderingStages.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
          <p className="privacy-content__text">
            No financial business is immune to criminal activities. Firms
            should consider the money laundering risks posed by their products
            and services.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={240}>
          <h2 className="privacy-content__heading">
            What is Counter-Terrorist Financing (CTF)
          </h2>
          <p className="privacy-content__text">
            Terrorist financing is a process in which legitimate businesses and
            individuals may choose to provide funding to terror organizations or
            their activities for ideological, political, or other reasons. Firms
            must ensure that: (i) customers are not terrorist organizations
            themselves, and (ii) they are not providing means through which
            terrorist organizations can be funded.
          </p>
          <p className="privacy-content__text">
            Terrorist financing may not involve proceeds from criminal conduct.
            It is an attempt to conceal the origin or intended use of the funds
            that can be later used for criminal purposes.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={280}>
          <h2 className="privacy-content__heading">Risk-Based Approach</h2>
          <p className="privacy-content__text">
            A certain level of due diligence is required to counter
            anti-money laundering within the firm. This takes a risk-based
            approach, meaning the amount of resources spent for due diligence in
            any relationship subject to risk should be in proportion to the
            magnitude of the risk.
          </p>
        </Reveal>

        <Reveal className="privacy-content__block" delay={320}>
          <h2 className="privacy-content__heading">This can be broken down into:</h2>
          <h3 className="privacy-content__subheading">Customer Risk</h3>
          <p className="privacy-content__text">
            Different customer profiles have different levels of risk. A basic
            &apos;Know your Customer (KYC) check&apos; may help assess any risk.
            For example, a nearly retired individual making small, regular
            contributions to a savings account in line with their financial
            details poses less of a risk than a mid-aged individual making
            ad-hoc payments of ever-changing sizes into a savings account that
            does not fit into the customer profile&apos;s standing financial
            data.
          </p>
          <p className="privacy-content__text">
            The intensity of due diligence conducted on the latter would be
            higher than that on the former as the potential of money laundering
            in the second case could be perceived as greater. Corporate
          </p>
          <p className="privacy-content__text">
            structures can be examples of customers that may carry a higher
            risk profile, as they can be used by criminals to introduce layers
            within transactions to conceal the source of the funds.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Content;
